import { SubscriptionEndDateFilterValue } from '../config';

// Mirrors exactly what the request carries: a period picked without dates
// filters nothing, so the column must not claim to be filtered.
export const isSubscriptionEndDateFiltered = (
  value: SubscriptionEndDateFilterValue,
) => !!value.from || !!value.to || value.onlyActive;
